import React from "react";

import {
  unavailablePointGroupsOf,
  unavailablePointsText,
} from "../../../services/valuation";
import { DateFormat, formatDate } from "../../../utils";
import { ButtonTypes } from "../../../components/Button";
import { Note, NoteButton, NoteRow } from "./styles";
import { UnavailablePointsNoteProps } from "./types";

// The button is narrower than the note on purpose: a private price clears only the coverage reasons, so a correction-blocked line gets no way into a panel that cannot repair it.
export const UnavailablePointsNote: React.FC<UnavailablePointsNoteProps> = ({
  points,
  onSetPrice,
  className,
}) => {
  const rows = unavailablePointGroupsOf(points).map((group) => ({
    key: group.key,
    text: unavailablePointsText(group),
    repairAsOf: group.repairAsOf,
    repairLabel:
      onSetPrice && group.isRepairable
        ? `Set my price for ${formatDate(group.repairAsOf, DateFormat.DMY_SPACE)}…`
        : null,
  }));
  if (rows.length === 0) {
    return null;
  }

  return (
    <Note role="note" className={className}>
      {rows.map((row) => (
        <NoteRow key={row.key}>
          <span>{row.text}</span>
          {row.repairLabel && (
            <NoteButton
              type={ButtonTypes.link}
              size="small"
              onClick={() => onSetPrice?.(row.repairAsOf)}
            >
              {row.repairLabel}
            </NoteButton>
          )}
        </NoteRow>
      ))}
    </Note>
  );
};
